import { userSavedSearchEntityAdapter } from "./adapter";

import type { RootState } from "../../types";

export const getUserSavedSearchState = (state: RootState) =>
  state.userSavedSearches;

const { selectAll: selectAllSavedSearches } =
  userSavedSearchEntityAdapter.getSelectors(getUserSavedSearchState);

export { selectAllSavedSearches };
